import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { PlanetProps } from "Data/planet";
import ContainerMd from "./Containers/ContainerMd";
import PlanetList from "./PlanetList";
import { useIsListClicked, useHomeLoaded } from "Provider/HomeProvider";
import useWindowSize from "Hooks/useWindowSize";
import media, { BREAKPOINT_TABLET, BREAKPOINT_MOBILE } from "Styles/media";
import useScroll from "Hooks/useScroll";
import { useHeaderState } from "Provider/AppProvider";
import { render } from "Threejs/listArrayRender";
import theme from "Styles/theme";

// INTERFACE
interface PlanetListWrapperProps {
	data: PlanetProps[];
	setNowId: React.Dispatch<React.SetStateAction<string>>;
}

// STYLED
const Wrapper = styled.div<{ active: boolean }>`
	position: absolute;
	width: 100%;
	${(props) => props.theme.layout.full_height_layout};

	padding-top: ${(props) => `${props.theme.size.offset.pc * 2 + props.theme.size.logo.pc}px`};
	padding-bottom: ${(props) => `${props.theme.size.offset.pc * 2 + props.theme.size.logo.pc}px`};

	overflow: scroll;
	left: 0;
	top: 0;
	z-index: ${(props) => props.theme.zIndex.planetList};
	opacity: ${(props) => (props.active ? 1 : 0)};
	transition: ${(props) => props.theme.transition.default};
	transform: ${(props) => `translateY(${props.active ? 0 : "32px"});`};

	${(props) => (props.active ? props.theme.event.able : props.theme.event.disable)};
	${(props) => props.theme.layout.scroll_hide};

	@media ${media.tablet} {
		padding-top: ${(props) => `${props.theme.size.offset.tablet * 2 + props.theme.size.logo.tablet}px`};
		padding-bottom: ${(props) => `${props.theme.size.offset.tablet * 2 + props.theme.size.logo.tablet}px`};
	}
`;
const Container = styled(ContainerMd)`
	/* position: relative; */
`;
const Inner = styled.div`
	position: relative;
`;

const ListWrapper = styled.ul`
	display: flex;
	flex-wrap: wrap;
	position: relative;
`;

const ThreeListArray = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	${(props) => props.theme.event.disable};
`;

const PlanetListWrapper: React.FC<PlanetListWrapperProps> = ({ data, setNowId }) => {
	const { isListClicked } = useIsListClicked();
	const [ratio, setRatio] = useState(65);
	const [col, setCol] = useState(3);
	const { size } = useWindowSize();
	const { element, value } = useScroll();
	const { setHeaderState } = useHeaderState();
	const { setHomeLoaded } = useHomeLoaded();
	const threeRef = useRef<HTMLDivElement>(null);

	const handleListClick = (id: string) => {
		setNowId(id);
	};

	useEffect(() => {
		setTimeout(() => {
			if (threeRef.current !== null && data) {
				render(threeRef.current, data, setHomeLoaded);
			}
		}, 500);
	}, [threeRef, data, setHomeLoaded]);

	useEffect(() => {
		if (size.width <= BREAKPOINT_MOBILE) {
			setCol(1);
		} else if (size.width <= BREAKPOINT_TABLET) {
			setCol(1);
		} else {
			setCol(3);
		}
	}, [size]);

	useEffect(() => {
		if (size.width <= BREAKPOINT_MOBILE) {
			setRatio(theme.size.three.listRatio_min);
		} else {
			setRatio(theme.size.three.listRatio);
		}
	}, [size]);

	useEffect(() => {
		if (size.width <= BREAKPOINT_MOBILE) {
			setHeaderState((n) => ({
				...n,
				solid: value > 32
			}));
		}
	}, [value, size, setHeaderState]);

	return (
		<Wrapper active={isListClicked} ref={element}>
			<Container>
				<Inner>
					<ListWrapper>
						{data.map((el, index) => {
							return <PlanetList key={el.id} data={el} index={index} ratio={ratio} col={col} onClick={() => handleListClick(el.id)} />;
						})}
					</ListWrapper>
					<ThreeListArray ref={threeRef} />
				</Inner>
			</Container>
		</Wrapper>
	);
};

export default PlanetListWrapper;
